import { EditComponent } from '../../app-lite/table/cell-components/actions/edit.component';

export function CustomerEventsCtrl (
  $scope,
  $state,
  $translate,
  tableApi,
  workshopAPI
) {
  $scope.showCustomerEvents = !!$scope.events.length;
  $scope.tableCacheKey      = 'customerEvents';

  $scope.tableSettings = {
    cache: {
      enabled: true,
      key    : $scope.tableCacheKey
    },
    columns: [
      {
        classes: 'all-caps',
        field  : 'event_number',
        header : {
          text: $translate.instant('JS_SPACE.COLUMNS.BOOKING_NUMBER')
        },
      },
      {
        field : 'event_date',
        header: {
          text: $translate.instant('BOOKING_SPACE.BOOKING_DATE')
        },
        pipe: 'globalDate'
      },
      {
        field : 'event_status',
        header: {
          text: $translate.instant('GENERAL_SPACE.FIELD.STATUS')
        },
        pipe: 'invoiceStatus'
      },
      {
        field : 'description',
        header: {
          text: $translate.instant('GENERAL_SPACE.FIELD.DESCRIPTION')
        }
      },
      {
        field : 'total',
        header: {
          text: $translate.instant('GENERAL_SPACE.FIELD.TOTAL')
        },
        pipe: 'globalCurrency'
      },
      {
        component: {
          bindings: {
            outputs: {
              onEditClick: event => $scope.viewEvent(event)
            }
          },
          enabled: !$scope.customer.archived,
          factory: EditComponent,
        },
        sortable: false,
      }
    ],
    empty: {
      text: $translate.instant('QUERY_DROPDOWN_SPACE.GRID.NO_BOOKINGS_FOUND')
    },
    pagination: {
      enabled   : true,
      pageSize  : tableApi.getCachedPaging($scope.tableCacheKey).pageSize || 5,
      pageSizes : [ 5, 10, 25, 50 ],
      queryCount: () => workshopAPI.get('/customers/event_count/' + $scope.customer.id)
    },
    rows: {
      highlight: {
        enabled: true
      }
    },
    sorting: tableApi.setSortingFromCache($scope.tableCacheKey, {
      direction: 'desc',
      field    : 'event_date'
    })
  };

  $scope.getEvents = ( params ) => {
    return workshopAPI.get('/customers/event_list', [
      $scope.customer.id,
      params.offset,
      params.pageSize,
      params.field,
      params.direction
    ]).then(events => {
      $scope.events = events;

      return events;
    });
  };

  $scope.onRowDoubleClick = function (event) {
    if ( !$scope.customer.archived ) {
      $state.go('app.event', {
        customer_id: $scope.customer.id,
        id         : event.row.id,
        vehicle_id : event.row.vehicle_id
      });
    }
  };

  $scope.viewEvent = function (event) {
    $state.go('app.event', {
      customer_id: $scope.customer.id,
      id         : event.id,
      vehicle_id : event.vehicle_id
    });
  };
}